

import state from './moduleCitiesState.js'
import mutations from './moduleCitiesMutations.js'
import actions from './moduleCitiesActions.js'
import getters from './moduleCitiesGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

